import styled, { css } from 'styled-components';

const HeaderBannerStyled = styled.div.attrs({
  className: 'header-banner',
})`
  ${({ theme, backgroundColor }) => {
    const { colors, media } = theme;

    return css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 16px 32px;
      margin-bottom: 24px;
      background-color: ${colors.primary[backgroundColor] || colors.primary.white};
      color: ${colors.primary.darkBlue};
      border-radius: 8px;
      border: 1px solid ${colors.secondary.pumice};
      flex-direction: column;

      ${media.tablet.up} {
        margin-bottom: 32px;
        flex-direction: row;
      }

      ${media.desktop.up} {
        margin-bottom: 48px;
      }

      .header-banner {
        &__icon-wrapper {
          display: flex;
          align-items: center;

          svg,
          path {
            fill: ${colors.primary.red};
            color: ${colors.primary.red};
          }
        }
        &__icon-plus {
          width: 10px;
          height: 20px;
          margin-left: 16px;
        }
        &__icon-netflix {
          width: 86px;
          height: 24px;
          margin-left: 16px;
        }
        &__text-block {
          font-size: 1rem;
          line-height: 1.25;
          font-weight: 400;
          margin: 16px 16px;

          ${media.tablet.up} {
            margin: 0px 16px;
        }
        }
        &__modal {
          font-weight: 700;
          background: transparent;
          font-size: 1rem;
          line-height: 1.25;
          margin-left: 4px;
          border: none;
          text-decoration: underline;
          cursor: pointer;
        }
        &__toggle-cta {
          background: transparent;
          border: 1px solid;
          border-radius: 32px;
          min-width: 208px;
          color: ${colors.primary.darkBlue};
          cursor: pointer;
          font-weight: 700;
          font-size: 1rem;
          line-height: 1.5;
          padding: 8px 16px;
        }
        &__arrow-down {
          transform: rotate(90deg);
          width: 16px;
          height: 13px;
          margin-left: 5px;
        }
      }
    `;
  }}
`;

export default HeaderBannerStyled;
